import { render, staticRenderFns } from "./WidgetMenu.vue?vue&type=template&id=77c81b48&scoped=true"
import script from "./WidgetMenu.vue?vue&type=script&lang=js"
export * from "./WidgetMenu.vue?vue&type=script&lang=js"
import style0 from "./WidgetMenu.vue?vue&type=style&index=0&id=77c81b48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c81b48",
  null
  
)

export default component.exports